import { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./HomeworkSourcesUIHelpers";

const HomeworkSourcesUIContext = createContext();

export function useHomeworkSourcesUIContext() {
  return useContext(HomeworkSourcesUIContext);
}

export const HomeworkSourcesUIConsumer = HomeworkSourcesUIContext.Consumer;

export function HomeworkSourcesUIProvider({ sourcesUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openImportFromExcelDialog: sourcesUIEvents.openImportFromExcelDialog,
    openNewHomeworkSourcePage: sourcesUIEvents.openNewHomeworkSourcePage,
    openEditHomeworkSourcePage: sourcesUIEvents.openEditHomeworkSourcePage
  };

  return (
    <HomeworkSourcesUIContext.Provider value={value}>
      {children}
    </HomeworkSourcesUIContext.Provider>
  );
}